<template>
    <section class="mt-16">
      <v-row>
        <v-col cols="12" offset="0" md="10" offset-md="1">    
          <v-breadcrumbs
              large
              :items="crumbs"
              divider="/"
              light
              :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
            ></v-breadcrumbs>
      
            <h1 class="primary--text">
              <v-icon color="primary">mdi-truck-delivery</v-icon> <span>Ficha de Fornecedor</span>
            </h1>
      
            <div class="mt-16">
              <v-progress-linear v-if="loading"
                indeterminate
                class="global-loader"
              ></v-progress-linear>
      
              <template v-if="loading">
                <v-row>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader
                      type="text"
                    ></v-skeleton-loader>
                  </v-col>
                </v-row>
                <v-row align="center" justify="space-around">
                  <v-skeleton-loader
                      type="button"
                    ></v-skeleton-loader>
                </v-row>
              </template>
              <Supplier v-else method="update" :supplier="supplier"></Supplier>
            </div>
          </v-col>
        </v-row>


    </section>
  </template>
  <script>
  import Supplier from '@/components/Suppliers/Supplier'
  import SupplierAPI from "@/api/Suppliers.js";
  
  export default {
    components: {
      Supplier
    },
    data: () => ({
        supplier: {},
        loading:true
    }),
    mounted(){
  
      if(!this.$store.getters.hasPermission(["super", "fornecedores.read"])) {
        this.$router.push('/admin');
      }
  
      SupplierAPI.find(this.$route.params.id).then(({data}) => { this.supplier = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: true,
            exact: true,
          },
          {
            text: 'Ficha de Fornecedor',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  